export const countryProfile = {
  countrySummary: {
    text: "Resumo do país",
    keyContacts: "Contactos chave",
    resources: "Recursos",
  },
  exportCountryDataButton: "EXPORTAÇÃO DE DADOS DO PAÍS",
  downloadScorecard: "DESCARREGAR QUADRO DE PONTUAÇÃO",
  overallDigitalHealthPhase: "FASE GLOBAL DE SAÚDE DIGITAL",
  overallDigitalHealthPhaseDescription:
    "A nota global é uma média das notas dos indicadores GDHM",
  benchmark: {
    text: "DINAMARCA",
    textWithData: "DINAMARCA: {data}",
    benchmarkValues: {
      globalAverage: "Média Global",
      atAvg: "EM MÉDIA",
      belowAvg: "ABAIXO MÉDIO",
      aboveAvg: "SOBRE A MÉDIA",
    },
    benchmarkDescription:
      "Compare a sua pontuação global com a Média Global ou com as fases de outros países",
    benchmarkNoCountryForSelectedPhase:
      "Nenhum país na fase selecionada para comparar",
    serverErrorDescription:
      "Incapaz de carregar dados de referência. Por favor, tente depois de algum tempo",
    average: "Média",
  },
  indicator: "Indicador",
  score: "PONTUAÇÃO",
  govtData: "Aprovado pelo governo",
  nonGovtData: "Aprovação governamental pendente",
  selectYear: "Selecione o ano",
  selectYearDescription:
    "Para visualizar os dados de um ano específico, selecione o ano desejado",
  phaseOverview: "Visão geral da fase",
  countryProgressOverTime: "Progresso do país ao longo do tempo",
  countryProgressLineChart: {
    indicatorGroupingDescription: "Selecione um indicador",
    globalAverage: "Média global",
  },
  compareTo: "Comparado a",
  region: "Região",
};
